import * as React from 'react';
import { Box } from 'rebass';
import { renderFormatColumnStyleSummary } from '../../../View/FormatColumn/Wizard/FormatColumnStyleWizardSection';
export const getFormatColumnStyleViewItems = (formatColumn, api) => {
    return React.createElement(Box, { mt: 2 }, renderFormatColumnStyleSummary(formatColumn, api));
};
